import api from './api';

export interface CommunicationMessage {
  id: number;
  author_id: string;
  author_name: string;
  message: string;
  created_at: number;
}
export interface Conversation {
  conversation_id: string;
  pro: string;
  sender_name: string;
  is_sender: boolean;
  is_recipient: boolean;
  recipient_name: string;
  status: 'OPEN' | 'RESOLVED';
  updated_at: number;
  preview: string;
  unread: boolean;
  last_message_id: number;
  messages?: CommunicationMessage[];
}
export interface CommunicationAudience {
  value: string;
  label: string;
  description: string;
}
const root = '/communications';
export const communications = {
  list: async (pro?: string) => (await api.get<Conversation[]>(root, { params: pro ? { pro } : {} })).data,
  audience: async (pro: string) => (await api.get<CommunicationAudience[]>(`${root}/audience/${pro}`)).data,
  create: async (pro: string, target: string, message: string) =>
    (await api.post<Conversation>(root, { pro, target, message })).data,
  detail: async (id: string) => (await api.get<Conversation>(`${root}/${id}`)).data,
  reply: async (id: string, message: string) => (await api.post<Conversation>(`${root}/${id}/messages`, { message })).data,
  resolve: async (id: string) => (await api.post<Conversation>(`${root}/${id}/resolve`)).data,
  read: async (id: string, messageId: number) => api.post(`${root}/${id}/read`, { message_id: messageId }),
};
export function communicationError(error: unknown): string {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === 'string' ? detail : 'Could not load or save the communication. Please try again.';
}
export const COMMUNICATIONS_CHANGED = 'communications-changed';
export const refreshCommunications = () => window.dispatchEvent(new Event(COMMUNICATIONS_CHANGED));

export const needsCommunicationAttention = (row: Conversation): boolean => row.status === 'OPEN' && row.is_recipient;
